import React from "react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import FinalCTA from "../components/site/FinalCTA";
import { Dot } from "../components/site/Section";

const pillars = [
  { title: "Made for a working shift", body: "Designed for the phone, for a cellar with poor signal and a team with little time. It works on desktop too." },
  { title: "Clear numbers", body: "GP, waste and supplier prices in pounds and percentages, in the words you already use." },
  { title: "Your data stays yours", body: "Export it whenever you like. We never sell it, and moving plans never loses it." },
  { title: "Priced for independents", body: "Clear prices on the website, one price per venue, and you can start tonight without a sales call." },
];

export default function About() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <section className="page-head">
          <div className="wrap story">
            <div>
              <h1>
                <span className="label h1-kicker">About Barlo</span>
                Built by people who have done the Monday stocktake<Dot />
              </h1>
            </div>
            <div className="story-text">
              <p>We've worked in hospitality for 11 years, and stock has always been the part of the job that took the most time.</p>
              <p>Every Monday morning meant hours counting stock, then ordering from each supplier one by one. Everything was on paper, so there was no real way to keep track of what suppliers were charging or to notice when a price had gone up.</p>
              <p>We looked at the systems available. They were expensive and built for restaurant chains and large companies, not for an independent bar or restaurant.</p>
              <p>So we built Barlo. You film the shelf instead of writing it down, the order builds itself from your par levels, and price rises show up when the invoice comes in.</p>
            </div>
          </div>
        </section>
        <section style={{ paddingTop: 0 }}>
          <div className="wrap">
            <div className="group-title" style={{ marginTop: 0 }}><h2>What Barlo is built around</h2></div>
            <div className="pillars">
              {pillars.map((p) => (
                <article className="fcard" key={p.title}><h3>{p.title}</h3><p>{p.body}</p></article>
              ))}
            </div>
          </div>
        </section>
        <FinalCTA testidTrial="about-cta-trial" />
      </main>
      <Footer />
    </div>
  );
}
